import React from "react";
import { BackTop } from "antd";
import "./CookiePolicy.css";

class CookiePolicyPage extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div className="constrain">
        <div className="cookie-policy-container">
          <div className="cookie-policy-header">
            <h1>COOKIE POLICY</h1>
            <p className="last-updated">Last Updated: December 2025</p>
          </div>

          <div className="cookie-policy-content">
            {/* Table of Contents */}
            <div className="table-of-contents">
              <h2>Table of Contents</h2>
              <ol>
                <li><a href="#section-1">Introduction</a></li>
                <li><a href="#section-2">Cookie Policy</a></li>
                <li><a href="#section-3">What Are Cookies</a></li>
                <li><a href="#section-4">Third-Party Cookies</a></li>
                <li><a href="#section-5">Tracking</a></li>
                <li><a href="#section-6">Changes or Modifications</a></li>
                <li><a href="#section-7">EU/EEA and UK Residents</a></li>
                <li><a href="#section-8">Contact Information</a></li>
              </ol>
            </div>

            {/* Section 1 */}
            <section id="section-1" className="cookie-policy-section intro-section">
              <h2>1. Introduction</h2>
              <p>
                No Cap Vote, ("No Cap Vote," "our," "us," or "we"), our affiliates, partners, vendors, and advertisers 
                collect information through automated means, such as web beacons, pixels, server calls, and other similar 
                tracking technologies when you access or use our Site, Services, emails, or newsletters. The Cookie Policy 
                applies to the website, <a href="https://www.nocapvote.com">www.nocapvote.com</a>, and explains how we 
                obtain, use, and manage cookies to remember the preferences that you choose, so we may deliver personalised 
                and relevant content, products, advertising, or services to you.
              </p>
              <p>
                Please read the Cookie Policy, including the{" "}
                <a href="https://www.nocapvote.com/privacypolicy">Privacy Policy</a>, carefully before you access or use 
                the Site or Services. By accessing or using the Site or Services, you acknowledge, accept, and agree to our 
                use of cookies, as described in this notice. If you do not agree with the Cookie Policy, you may not access 
                or use the Site or Services.
              </p>
            </section>

            {/* Section 2 */}
            <section id="section-2" className="cookie-policy-section">
              <h2>2. Cookie Policy</h2>
              <p>
                We, at our sole discretion, and/or our third-party affiliates, such as service providers, advertisers, 
                technology providers, and the like, may use cookies, URL information, web beacons, server logs, and other 
                similar technologies to automatically collect information when you access or use content for the purpose of:
              </p>
              <ul className="letter-list">
                <li>(a) enhancing, upgrading, maintaining, managing, and/or improving your web experience, allowing us to 
                identify your performance from other users, such as content you viewed, time and date of use; and</li>
                <li>(b) assisting us to tailor our Services that may interactively meet your needs, interests, and 
                preferences.</li>
              </ul>
              <p>
                We provide you with optional tools and controls to manage your experience and preferences of the Services. 
                Cookies do not give us access to your computer or any information about you, other than the information you 
                share with us.
              </p>
            </section>

            {/* Section 3 */}
            <section id="section-3" className="cookie-policy-section">
              <h2>3. What Are Cookies</h2>
              <p>
                Cookies are small text files or code that may be sent to, then stored by, the web browser software on a 
                user's computer hard drive or Devices by a server to enhance your experience, which assists us in collecting 
                information about you and Your Account to:
              </p>
              <ul>
                <li>provide or deliver content, advertisements, and other functions to you by using cookies, pixels, tags, 
                beacons, scripts, ("cookies"), and other similar technologies;</li>
                <li>identify the user's browser type, apps, or sites used before or after accessing or using the Site or 
                Services;</li>
                <li>store your IP address, account username(s), and/or password(s);</li>
                <li>analyze and monitor geolocation-related data and web traffic data;</li>
                <li>recognize your activities, your next visit, frequency, and duration;</li>
                <li>allow web applications to recognize, maintain, or customize your preferences, likes or dislikes;</li>
                <li>identify content, data, texts, advertisements, or pages that you provide or are being viewed, used, 
                interacted, and engaged with;</li>
                <li>identify websites you visited, apps downloaded, or actions taken;</li>
                <li>allow you to log into secure areas of our Services;</li>
                <li>identify purchase information that you made or advertised with us or third parties using billing 
                information, Personal Information, a shopping card, credit card or other financial information, or making 
                use of e-billing services; and</li>
                <li>compile, destroy, de-identify, aggregate or anonymize information to not identify you.</li>
              </ul>
              <p>
                At any time, you may edit, update, manage, delete, or correct your Personal Information, account settings, 
                privacy choices, preferences, geolocation, or opt out of targeted ads, special offers, or promotions through 
                Your Account settings at <a href="https://www.nocapvote.com">www.nocapvote.com</a> on each device you use. 
                Before installing or using the Services, subject to Applicable Laws, you will be asked to consent to certain 
                cookies. Most browsers and devices accept cookies by default where you may clear and decline cookies. By 
                modifying your web browser setting, declining, disabling, or restricting your use of any cookies may, 
                simultaneously, result in an inferior web experience, you may not be able to take full advantage of the 
                contents, benefits, invitations, products, or services, which may also impact the features and 
                functionalities of the Services.
              </p>
            </section>

            {/* Section 4 */}
            <section id="section-4" className="cookie-policy-section">
              <h2>4. Third-Party Cookies</h2>
              <p>
                We may engage with Diverse Entities, websites, digital properties and/or their servers, third-party cookies, 
                and other varying platforms to create or collect a profile of your interests:
              </p>
              <ul>
                <li>based your visits or sign-ins with other websites and social networks, such as TikTok, X, LinkedIn, 
                Facebook, Snap, Meta, and other external networks and platforms through enabling the social share buttons;</li>
                <li>based on publicly-available sources; or</li>
                <li>based on your interactions, feedback, or experiences that are provided to you or us; and</li>
                <li>for advertising purposes, customizing ad campaigns, or display functions to reach current and new 
                audiences.</li>
              </ul>
              <p>
                We do not control the dissemination of these cookies or third-party digital properties, and we are not 
                responsible for any information you voluntarily choose to disclose to third parties. Social share buttons are 
                for users to bookmark web pages. By placing third-party plug-ins and widgets on our Services, the third 
                parties may place identifying cookies on your browser. Temporary cookies may be stored on your device(s) 
                while in use and deleted when you close your web browser or refrain from using applications. However, users 
                who may access or use the Site or Services from the European Union, Canada, or the United Kingdom are 
                requested to give consent before storing cookies on your devices. Additionally, your consent may be requested 
                for other cookies that are stored on your device(s) to track your online activity(ies) and targeted 
                advertising on the Services until expired or removed. We strictly utilize the necessary cookies allowing you 
                to navigate the Site, Services, and use its features.
              </p>
              <p>
                You may opt out of targeted advertising by disabling, managing, or removing cookies, which may limit your 
                online activity(ies). However, opting out of these tracking technologies may not guarantee the 
                functionalities, features, advertisements, content, or campaigns you expect to continue to receive, but may 
                still be shared with our subsidiary(ies), affiliates, associates, and/or service providers. Furthermore, we 
                may continue to send non-marketing materials or information about Your Account or transactions you've made.
              </p>
            </section>

            {/* Section 5 */}
            <section id="section-5" className="cookie-policy-section">
              <h2>5. Tracking</h2>
              <p>
                We engage with third-party tracking technologies, automated methods or techniques, and advertising providers 
                to act on our behalf to track and analyze your access or use of the Site or Services through the use of 
                pixels, tags, beacons, software, and other similar technologies:
              </p>
              <ul>
                <li>for statistical purposes;</li>
                <li>to count the number of visitors or users returning to our Site or using our Services;</li>
                <li>to compile reports about how visitors use our Services;</li>
                <li>to collect information to quantify and examine the performance of our advertisers; and/or</li>
                <li>to track page usage and Internet banner advertisements.</li>
              </ul>
              <p>
                When you return to the Site, your browser lets us read the tags. Pixels or tags do not place any information 
                on your device. However, pixels or tags are used for purposes of monitoring the effectiveness of your visit 
                on the Site or Services.
              </p>
            </section>

            {/* Section 6 */}
            <section id="section-6" className="cookie-policy-section">
              <h2>6. Changes or Modifications</h2>
              <p>
                At our sole discretion, we may periodically modify, amend, or change this Cookie Policy and shall be 
                effective upon the date of posting.
              </p>
            </section>

            {/* Section 7 */}
            <section id="section-7" className="cookie-policy-section">
              <h2>7. EU/EEA and UK Residents</h2>
              <p>
                Subject to the European Union's General Data Protection Regulations, ("GDPR") and the United Kingdom's 
                General Data Protection Regulation, ("UK GDPR"), we will make reasonable measures to comply with applicable 
                international consumer data privacy laws. Subject to Applicable Laws, if you are a resident of the EU/EEA, 
                United Kingdom, or Switzerland, the collection and use of your Personal Information is in the interest of our 
                internal or external business-related purposes, growth, maintenance, or security only.
              </p>
              <p>
                If you would like more information, or to request to opt out of the consent to collect or use your Personal 
                Information, please contact us at <a href="mailto:notice@nocapvote.com">notice@nocapvote.com</a>.
              </p>
            </section>

            {/* Section 8 */}
            <section id="section-8" className="cookie-policy-section contact-section">
              <h2>8. Contact Information</h2>
              <p>
                If you have any questions, or need further assistance, please contact No Cap Vote at{" "}
                <a href="mailto:notice@nocapvote.com">notice@nocapvote.com</a>.
              </p>
            </section>
          </div>
        </div>
        <BackTop />
      </div>
    );
  }
}

export default CookiePolicyPage;